import { render, staticRenderFns } from "./df-app-navigation.vue?vue&type=template&id=611fe401"
import script from "./df-app-navigation.ts?vue&type=script&lang=js&external"
export * from "./df-app-navigation.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports